import request from '@/utils/request';


export default {
    fpaLtoList: (param) => {
        return request({
            url: `/fpaLto/fpaLtoList`,
            method: 'post',
            data: param
        });
    },

    fpaLtoDetail : (ttFpaLtoId) => {
        return request({
            url: `/fpaLto/fpaLtoDetail?ttFpaLtoId=`+ttFpaLtoId,
            method: 'get',
            data : ttFpaLtoId
        });
    },

    fpaLtoSubmit: (param) => {
        return request({
            url: `/fpaLto/fpaLtoSubmit`,
            method: 'post',
            data: param
        });
    },

    fpaLtoApprove: (param) => {
        return request({
            url: `/fpaLto/fpaLtoApprove`,
            method: 'post',
            data: param
        });
    },

    fpaLtoPdfDownload : (param) => {
        return request({
            url: `/fpaLto/fpaLtoPdfDownload`,
            fullResponse: true,
            responseType: 'blob',
            method: 'post',
            data : param
        });
    },

}



